'use client';

import { useEffect, useState } from 'react';

/**
 * Becomes true once `google.maps.Map` exists. The Maps script must be loaded
 * exactly once (see `app/(Storefront)/providers.tsx`); do not inject a second
 * copy via `react-load-script` — that breaks the API with "included multiple times".
 */
export function useGoogleMapsJsReady(): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    if (window.google?.maps?.Map) {
      setReady(true);
      return;
    }
    const id = window.setInterval(() => {
      if (window.google?.maps?.Map) {
        setReady(true);
        window.clearInterval(id);
      }
    }, 50);
    return () => window.clearInterval(id);
  }, []);

  return ready;
}
